import React from 'react';
import { Box, Button, Container, Grid, Typography, useTheme } from '@mui/material';
import { Scrollbars } from 'react-custom-scrollbars-2';

import Hero from '../components/misc/Hero';
import Features from '../components/misc/Features';
import CTA from '../components/misc/CTA';
import Pricing from '../components/misc/Pricing';
import About from '../components/misc/About';
import HowItWorks from '../components/misc/HowItWorks';
import FAQSection from '../components/misc/FAQSection';
import ContactInfo from '../components/misc/ContactInfo';
import Footer from '../components/misc/Footer';

const LandingPage = () => {
    const theme = useTheme();

    return (
        <Box sx={{
            display: 'flex', flexDirection: 'column',
            width: '100%',
        }}>
            <Scrollbars
                autoHide
                hideTracksWhenNotNeeded
                renderTrackVertical={({ style }) => (
                    <div style={{ ...style, display: 'none' }} /> // Hide the vertical scrollbar
                )}
            >
                <Hero />
                <Features />
                <CTA />
                {/* <Pricing /> */}
                <About />
                <HowItWorks />
                <FAQSection />
                <ContactInfo />
                <Footer />
            </Scrollbars>
        </Box>
    );
};

export default LandingPage;
